export interface BundleOutputFile {
  /**
   * The normalized relative path to the output file (starting from `BundleResult#outputPath`),
   * with forward slashes and an extension.
   */
  outputPath: string;

  /**
   * The relative path to the entry file (starting from `BundleResult#inputPath`),
   * with forward slashes and an extension. This will only be set for files that were
   * listed in `entries`.
   */
  entryPoint?: string;

  /**
   * The list of export names coming from the output file.
   *
   * WARNING: This is not set by all bundlers!
   */
  exports?: string[];

  /**
   * Whether the file is a Worker.
   *
   * WARNING: This is not set by all bundlers!
   */
  isWorker?: boolean;
}
